import {
	Box,
	Tooltip,
	Typography,
} from "@mui/material"
import FlagIcon from "@mui/icons-material/Flag"
import { useSelector } from "react-redux"
import { selectToolPanelView, TOOL_PANEL_VIEW } from "../../../reducers/toolPanelViewSlice"
import { DYNAMIC_PANEL_TAB_INDEX_MAP, selectDynamicView } from "../../../reducers/dynamicViewSlice"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function ArticleCitation ({id, targetArticle, article, isUnassigned, getYearFromPublicationDate}) {
	const {workspaceId} = useWorkspaceContext()
	const view = useSelector((state) => selectToolPanelView(state, workspaceId))
	const openTab = useSelector((state) => selectDynamicView(state, workspaceId))
	
	const isNotUnassignedView = view !== TOOL_PANEL_VIEW.UNASSIGNED
	const isNotToolsTab = openTab !== DYNAMIC_PANEL_TAB_INDEX_MAP.TOOLS
	const isRecentlyViewed = view === TOOL_PANEL_VIEW.RECENTLY_VIEWED
	const isArticleSearchTab = openTab === DYNAMIC_PANEL_TAB_INDEX_MAP.ARTICLE_SEARCH
	const isImportTab = openTab === DYNAMIC_PANEL_TAB_INDEX_MAP.NON_PUBMED_IMPORT
	const shouldShowUnassignedFlag = (
		(isNotUnassignedView && isNotToolsTab) ||
		isRecentlyViewed || 
		isArticleSearchTab || 
		isImportTab
	)

	return (
		<Box
			sx={{ padding: "10px 5px 0px 0px" }}
		>
			<Typography
				variant={"articleTitle"}
				component={"div"}
				sx={{
					marginRight: "32px",
					whiteSpace: "pre-wrap"
				}}
			>
				{
					(id !== targetArticle) &&
					isUnassigned &&
					(shouldShowUnassignedFlag) &&
					(
						<Tooltip
							title={"This article is imported but un-attached"}
							placement={"left"}
						>
							<FlagIcon
								fontSize={"1rem"}
								sx={{
									color: "unassignedArticle.darker"
								}}
							/>
						</Tooltip>
					)
				}
				{article?.title}
			</Typography>
			<Typography variant={"authorsList"}>
				{article?.authors}
			</Typography>
			<Typography
				sx={{
					width: "90%",
					color: "RBOneFont.otherInfo",
					display: "inline",
				}}
				variant={"caption"}
				component={"div"}
			>
				{` ${article?.publication}`} {getYearFromPublicationDate(article?.date)};
				{article?.issue}:{article?.pages}
			</Typography>
		</Box>
	)
}